import { addHours } from "date-fns";
import moment from "moment";

export const handleOwnCollectTime = (time) => {
    if (!time || typeof time !== 'string') {
        return
    }

    const date = addHours(new Date(time), 1);
    const hour = moment(date).format(('HH:mm'));

    return hour;
}

export const formatOwnCollectStartAndEnd = (start, end) => {
    if (!start && !end) {
        return
    }

    const startHour = handleOwnCollectTime(start);
    const endHour = handleOwnCollectTime(end);

    if (startHour && endHour) {
        if (startHour === endHour) {
            return `${startHour}h`
        }

        return `${startHour}h - ${endHour}h`
    }

    if (startHour) {
        return `${startHour}h`
    }

    if (endHour) {
        return `${endHour}h`
    }
}

export const timeStringToDate = (time, baseDate) => {
    const [hoursStr, minutesStr] = time.split(":");
    const base = new Date(baseDate);

    if (
        !/^\d{2}:\d{2}$/.test(time) ||
        Number(hoursStr) > 23 ||
        Number(minutesStr) > 59
    ) {
        return null;
    }

    const result = new Date(base);
    result.setHours(Number(hoursStr));
    result.setMinutes(Number(minutesStr));
    result.setSeconds(0);
    result.setMilliseconds(0);

    return result;
}